import React, { useRef, useEffect } from "react";
import "../assets/styles/StarsCanvas.css"; // Adjust the path as necessary

const StarsCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    let stars = [];
    const numStars = 150;

    // Resize handler
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      initStars();
    };

    // Initialize stars
    const initStars = () => {
      stars = [];
      for (let i = 0; i < numStars; i++) {
        const depth = Math.random(); // 0 (far) to 1 (close)
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          radius: 0.5 + depth * 1.5,
          speed: 0.1 + depth * 1.5,
          dx: (Math.random() - 0.5) * depth * 0.1,
          opacity: 0.3 + depth * 0.7,
        });
      }
    };

    const drawStars = () => {
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  stars.forEach((star) => {
    ctx.beginPath();
    ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);

    // Add blur and shadow for glow effect
    ctx.shadowBlur = 15; // Adjust for stronger glow
    ctx.shadowColor = "rgba(255, 255, 255, 0.7)"; // Slightly stronger glow color
    ctx.fillStyle = `rgba(255, 255, 255, ${star.opacity})`;

    ctx.fill();
    ctx.closePath();

    // Update position
    star.y += star.speed;
    star.x += star.dx;

    // Wrap around when going out of bounds
    if (star.y > canvas.height) {
      star.y = 0;
      star.x = Math.random() * canvas.width;
      star.opacity = 0.3 + Math.random() * 0.7; // Randomize opacity again
    }

    if (star.x > canvas.width || star.x < 0) {
      star.x = Math.random() * canvas.width;
      star.y = Math.random() * canvas.height;
    }
  });

  requestAnimationFrame(drawStars);
};

    // Start animation
    initStars();
    drawStars();

    // Attach event listeners
    window.addEventListener("resize", resizeCanvas);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return <canvas ref={canvasRef} id="stars-canvas" />;
};

export default StarsCanvas;